import API from './API.js';
export default class MasterStatus extends API {
    constructor() {
        super('masterStatus');
    }

}
